import { Button, Flex } from "antd";
import { FilterIcon } from "../../assets";
import { Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import UserTable from "./UserTable";

export default function Users() {
  const popup = usePopup();

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm popup={popup} />
        </Popup>
        <AppliedFilter />
      </Flex>
      <UserTable />
    </>
  );
}
